import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./AdminParish.module.css";
// import plus from "../../../../Assets/plus.svg"
import { FaEdit, FaPen } from 'react-icons/fa';
// import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table,Row, Col} from 'react-bootstrap';
import HeaderNav from "../../FixedAssetReport/AdminNav/FixedAdminNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
// "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// import ToggleSlider from "./ToggleSlider";

const AdminParish = () => {
  const [searchTerm, sectSearchTerm] = useState("");
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [permId, setPermId] = useState([]);
  const [roleID, setRoleID] = useState([]);
  const [permLoading, setPermLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [toggleStates, setToggleStates] = useState({});
  const [roleStates, setRoleStates] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [roleCheckAll, setRoleCheckAll] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState([]);
  const [zones, setZones] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedParish, setSelectedParish] = useState('');
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [selectedRegionModal, setSelectedRegionModal] = useState(null);
  const [selectedProvinceModal, setSelectedProvinceModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [tableData5, setTableData5] = useState([]);
  const [tableData6, setTableData6] = useState([]);
  const [tableData7, setTableData7] = useState([]);
  const [tableData8, setTableData8] = useState([]);
  const [tableData9, setTableData9] = useState([]);
  const [tableData10, setTableData10] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [totalEntries, setTotalEntries] = useState("");
  // const [totalPages, setTotalPages] = useState(1);
  const [areaLoad, setAreaLoad] = useState(false);
  const [areas, setAreas] = useState([]);

  const [responseData, setResponseData] = useState([]);
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [continentName, setContinentName] = useState(null);
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [regionName, setRegionName] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [provinceName, setProvinceName] = useState(null);
  const [processLoading, setProcessLoading] = useState(false);
  const [processLoading1, setProcessLoading1] = useState(false);
  const [fetchMode, setFetchMode] = useState('default'); // 'default' or 'area'
  const [allReport,setAllReport] = useState(true);
  const [transferParishId, setTransferParishId] = useState(null);

  const [newUser, setNewUser] = useState({
    fullName: "",
    email: "",
    username: "",
    role: "",
    password: "",
    confirmPassword: ""
  });
  const [showTransferModal, setShowTransferModal] = useState(false);

const handleOpenModal = (item) => {
    console.log("Prepopulating with:", item); // Debugging check

    // 1. Save the Parish ID (for the API call later)
    setTransferParishId(item.id); 

    // 2. Set Continent
    // We set the ID (7). The <Select> will look into tableData10 to find "BROOKES CONTINENT"
    if (item.continent_id) {
        setSelectedContinent(item.continent_id);
        fetchSubContinents(item.continent_id); 
    }

    // 3. Set Region
    if (item.region_id) {
        setSelectedRegion(item.region_id);
        fetchSubRegions(item.region_id);
    }

    // 4. Set Province
    if (item.province_id) {
        setSelectedProvince(item.province_id);
        // Fetch Zones for this province
        fetchSubProvinces(item.province_id);
    }

    // 5. Set Zone
    if (item.zone_id) {
        setSelectedZone(item.zone_id);
        // Fetch Areas for this zone
        fetchSubZones(item.zone_id);
    }

    // 6. Set Area
    if (item.area_id) {
        setSelectedArea(item.area_id);
    }

    // 7. Show the modal
    setShowTransferModal(true);
};
const handleCloseModal = () => setShowTransferModal(false);
// --- New State for the Transfer Modal ONLY ---
const [transferContinent, setTransferContinent] = useState(null);
const [transferRegion, setTransferRegion] = useState(null);
const [transferProvince, setTransferProvince] = useState(null);
const [transferZone, setTransferZone] = useState(null);
const [transferArea, setTransferArea] = useState(null);

// --- New Handlers to ensure they don't affect the main form ---
const handleTransferContinent = (option) => {
  setTransferContinent(option);
  setTransferRegion(null); // Reset child fields
  setTransferProvince(null);
  setTransferZone(null);
  setTransferArea(null);
  // Add any API calls here if needed, e.g., fetchRegions(option.value)
};

const handleTransferRegion = (option) => {
  setTransferRegion(option);
  setTransferProvince(null); // Reset child fields
  setTransferZone(null);
  setTransferArea(null);
};

const handleTransferProvince = (option) => {
  setTransferProvince(option);
  setTransferZone(null);
  setTransferArea(null);
};

const handleTransferZone = (option) => {
  setTransferZone(option);
  setTransferArea(null);
};

const handleTransferArea = (option) => {
  setTransferArea(option);
};

  // Print View handler
  const handlePrintView = () => {
    navigate('/budget/charts_of_account/User');
  };

  // Pagination handlers
  // const handleFirstPage = () => {
  //   if (currentPage > 1) {
  //     handleProcess(1);
  //   }
  // };

  // const handleLastPage = () => {
  //   if (currentPage < totalPages) {
  //     handleProcess(totalPages);
  //   }
  // };

  // const handlePageClick = (page) => {
  //   if (page !== currentPage) {
  //     handleProcess(page);
  //   }
  // };



  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');
      const conName = await localStorage.getItem('continent');
      const proName = await localStorage.getItem('province');
      const regName = await localStorage.getItem('region');

      if (value !== null) {
        setBearer(value);
      }
      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
      if (conName !== null) {
        setContinentName(conName);
      }
      if (proName !== null) {
        setProvinceName(proName);
      }
      if (regName !== null) {
        setRegionName(regName);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

 

  const searchUsers = async (searchQuery, page = 1) => {
    if (!bearer) {
      return;
    }

    setSearchLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.get(`${BASE_URL}/users/search`, {
        headers,
        params: {
          variable: searchQuery,
          page: page
        }
      });

      console.log('Search API Response:', response);

      let usersData = [];
      let total = 0;
      let lastPage = 1;
      let currentPage = page;

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          usersData = response.data.data;
          total = usersData.length;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          usersData = response.data.data.data;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else if (response.data.data.users && Array.isArray(response.data.data.users)) {
          usersData = response.data.data.users;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            usersData = dataObj[arrayKeys[0]];
            total = dataObj.total || usersData.length;
            lastPage = dataObj.last_page || 1;
            currentPage = dataObj.current_page || page;
          } else {
            usersData = [dataObj];
            total = 1;
          }
        }
      } else if (Array.isArray(response.data)) {
        usersData = response.data;
        total = usersData.length;
      }

      setUsers(usersData);
      setTotalUsers(total);
      setTotalPages(lastPage);
      setCurrentPage(currentPage);

    } catch (error) {
      console.error("Error searching users:", error);
      setUsers([]);
      setTotalPages(1);
      setCurrentPage(1);
      setTotalUsers(0);
    } finally {
      setSearchLoading(false);
      setLoading(false);
    }
  };






  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    resetNewUserForm();
  };

  // Skeleton loader
  const SkeletonLoader = () => {
    return (
      <>
        {Array.from({ length: 5 }).map((_, index) => (
          <tr key={index}>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '120px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            {/* <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td> */}
            <td className={classes.btnAction}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };

  const fetchPermission = async () => {
    setPermLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/role/permissions`, { headers });
      const data = response.data?.data;
      const permissionId = data.map(item => item.id);
      setPermId(permissionId);

      const initialToggleStates = Object.fromEntries(data.map(item => [item.id, false]));

      setPermissions(data);
      setToggleStates(initialToggleStates);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setPermissions([]);
    } finally {
      setPermLoading(false);
    }
  };

  const fetRoles = async () => {
    setRoleLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/role/full-permissions`, { headers });
      const data = response.data?.data;
      const rolessId = data.map(item => item.id);
      setRoleID(rolessId);

      const initialToggleStates = Object.fromEntries(data.map(item => [item.id, false]));

      setRoles(data);
      setRoleStates(initialToggleStates);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setRoles([]);
    } finally {
      setRoleLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchPermission();
      fetRoles();
    }
  }, [bearer]);

  // Your existing toggle handlers...
  const handleToggleChange = (itemId) => {
    setToggleStates(prevToggleStates => ({
      ...prevToggleStates,
      [itemId]: !prevToggleStates[itemId],
    }));
  };

  const handleRoleToggleChange = (itemId) => {
    setRoleStates(prevRoleStates => {
      const updatedStates = {
        ...prevRoleStates,
        [itemId]: !prevRoleStates[itemId],
      };
      const allChecked = roles.every(role => updatedStates[role.id]);
      setRoleCheckAll(allChecked);
      const noneChecked = roles.every(role => !updatedStates[role.id]);
      if (noneChecked) setRoleCheckAll(false);
      return updatedStates;
    });
  };

  const handleCheckAllToggle = () => {
    const checkAllValue = !checkAll;
    setCheckAll(checkAllValue);
    const updatedToggleStates = Object.fromEntries(permissions.map(permission => [permission.id, checkAllValue]));
    setToggleStates(updatedToggleStates);
  };

  const handleCheckAllRoles = () => {
    const checkAllRoleValue = !roleCheckAll;
    setRoleCheckAll(checkAllRoleValue);
    const updatedToggleStates = Object.fromEntries(roles.map(role => [role.id, checkAllRoleValue]));
    setRoleStates(updatedToggleStates);
  };

  const [createLoading, setCreateLoading] = useState(false);



  const toIdArray = (val, key = "id") => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(x => (typeof x === "object" ? x[key] : x));
    if (typeof val === "object" && Array.isArray(val[key])) return val[key];
    if (typeof val === "number" || typeof val === "string") return [Number(val)];
    return [];
  };

  const asToggleMap = (allIds, selectedIds) =>
    Object.fromEntries(allIds.map(id => [id, selectedIds.includes(id)]));

  const handleOpenEdit = async (user) => {
    setEditingUser(user);

    // Basic info
    setFullName(user.name || user.full_name || "");
    setEmail(user.email || "");
    setPhone(user.phone_number || user.phone || "");
    setSelectedType(String(user.user_type_id || user.type_id || user.type || ""));

    // Set React Select values for modal
    if (user.continent_id || user.continent?.id) {
      const continentOption = continents.find(c => c.value == user.continent_id || c.value == user.continent?.id);
      setSelectedContinentModal(continentOption);
      if (continentOption) {
        // await fetchRegionsModal(continentOption.value);
      }
    }

    if (user.region_id || user.region?.id) {
      const regionOption = regionsModal.find(r => r.value == user.region_id || r.value == user.region?.id);
      setSelectedRegionModal(regionOption);
      if (regionOption) {
        // await fetchProvincesModal(regionOption.value);
      }
    }

    if (user.province_id || user.province?.id) {
      const provinceOption = provincesModal.find(p => p.value == user.province_id || p.value == user.province?.id);
      setSelectedProvinceModal(provinceOption);
    }

    // Modules and Roles
    const userModuleIds = toIdArray(user.modules) || toIdArray(user.module_ids) || toIdArray(user.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));

    const userRoleIds = toIdArray(user.roles) || toIdArray(user.role_ids) || toIdArray(user.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));

    setShow1(true);
  };
  // Update the reset function to include all fields
  const resetNewUserForm = () => {
    setFullName("");
    setFullName1("");
    setEmail("");
    setEmail1("");
    setPhone("");
    setPhone1("");
    setSelectedType("");
    setModalError("");
    setSelectedContinentModal(null);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    setToggleStates({});
    setRoleStates({});
    setCheckAll(false);
    setRoleCheckAll(false);
  };

  const fetchContinents = async () => {
    setIsLoading1(true);

    try {
      const response = await axios.get(`${BASE_URL1}/continents`, 
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TOKEN}`,
          },
        }
      );

      // console.log(response);
      const resultsss = response.data?.data;
      const options = resultsss.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData10(options);
      // console.log(results);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData10([]);
    } finally {
      setIsLoading1(false);
    }
  };
  useEffect(() => {
    if (TOKEN) {
      fetchContinents();
    }
  }, [TOKEN]);

  const fetchSubContinents = async (selectedContinent) => {
    setIsLoading1(true);

    try {
      const response = await axios.get(`${BASE_URL1}/continents/getcontinentregions?continent_id=${selectedContinent}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TOKEN}`,
          },
        });

      // console.log(response);
      const subCont = response.data?.data;
      const optionss = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(optionss);
      // console.log(subCont, "heeeer");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData4([]);
    } finally {
      setIsLoading1(false);
    }
  };



  const fetchSubRegions = async (selectedRegion) => {
    setIsLoading1(true);

    try {
      const response = await axios.get(`${BASE_URL1}/regions/getprovincesregion?region_id=${selectedRegion}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TOKEN}`,
          },
        });

      // console.log(response);
      const subReg = response.data?.data;
      const optionsss = subReg.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData5(optionsss);
      // console.log(subCont, "heeeer");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData5([]);
    } finally {
      setIsLoading1(false);
    }
  };


  const fetchSubProvinces = async (selectedProvince) => {
    setIsLoading(true);
   
    try {
      const response = await axios.get(`${BASE_URL1}/provinces/getzonesprovince?province_id=${selectedProvince}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TOKEN}`,
          },
        });

      // console.log(response);
      const subReg = response.data?.data;
      setTableData6(subReg);
      // console.log(subCont, "heeeer");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData6([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllZones = async (selectedProvince) => {
    setProvLoading(true);
 
    try {
      const response = await axios.get(`${BASE_URL1}/provinces/getzonesprovince?province_id=${selectedProvince}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TOKEN}`,
          },
        });

      // console.log(response);
      const subReg = response.data?.data;
      const optios = subReg.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setZones(optios);
      // console.log(subCont, "heeeer");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setZones([]);
    } finally {
      setProvLoading(false);
    }
  };



  const fetchSubZones = async (selectedZone) => {
    setIsLoading(true);
 
    try {
      const response = await axios.get(`${BASE_URL}/zones/getareaszone?zone_id=${selectedZone}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearer}`,
          },
        });

      // console.log(response);
      const subReg = response.data?.data;
      setTableData7(subReg);
      // console.log(subCont, "heeeer");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData7([]);
    } finally {
      setIsLoading(false);
    }
  };



  const fetchAllAreas = async (selectedZone) => {
    setAreaLoad(true);
    try {
      const response = await axios.get(`${BASE_URL1}/zones/getareaszone?zone_id=${selectedZone}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TOKEN}`,
          },
        });

      // console.log(response);
      const subReg1 = response.data?.data;
      const options1 = subReg1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setAreas(options1);
      // console.log(subCont, "heeeer");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setAreas([]);
    } finally {
      setAreaLoad(false);
    }
  };

  const fetchSubAreas = async (selectedArea) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/areas/getparishesarea?area_id=${selectedArea}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearer}`,
          },
        });

      // console.log(response);
      const subAreaa = response.data?.data;
      setTableData9(subAreaa);
      // console.log(subCont, "heeeer");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData9([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (TOKEN && selectedContinent) {
      fetchSubContinents(selectedContinent);
    }
  }, [TOKEN, selectedContinent]);

  useEffect(() => {
    if (bearer && selectedArea) {
      fetchSubAreas(selectedArea);
    }
  }, [bearer, selectedArea]);

  useEffect(() => {
    if (TOKEN && selectedProvince) {
      fetchAllZones(selectedProvince);
    }
  }, [TOKEN, selectedProvince]);

  useEffect(() => {
    if (TOKEN && selectedZone) {
      fetchAllAreas(selectedZone);
    }
  }, [TOKEN, selectedZone]);

  useEffect(() => {
    if (TOKEN && selectedRegion) {
      fetchSubRegions(selectedRegion);
    }
  }, [TOKEN, selectedRegion]);

  useEffect(() => {
    if (TOKEN && selectedProvince) {
      fetchSubProvinces(selectedProvince);
    }
  }, [TOKEN, selectedProvince]);

  useEffect(() => {
    if (bearer && selectedZone) {
      fetchSubZones(selectedZone);
    }
  }, [bearer, selectedZone]);



  const handleProcess = async (page = 1) => {
    setProcessLoading(true);
  
    try {
      const response = await axios.get(`${BASE_URL1}/parishes/fetch-by-type?continent_id=${continentID}&region_id=${regionID}&province_id=${provinceID}&page=${page}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
      });
  
      const results = response.data?.data?.parishes?.data;
      setTableData(results);
      const resultx = response.data?.data?.parishes?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.parishes?.last_page || 1;
      setTotalPages(total);
      setCurrentPage(page); // Set the current page
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
    } finally {
      setProcessLoading(false);
    }
  };
  

  useEffect(() => {
    if (TOKEN, continentID, regionID, provinceID) {
      handleProcess();
    }
  }, [TOKEN, continentID, regionID, provinceID]);

  const fetchAll = async (page = 1) => {
    setProcessLoading(true);
    try {
      const response = await axios.get(`${BASE_URL1}/parishes/get-parishes?page=${page}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
      });
  
      const results = response.data?.data?.parishes?.data;
      const resultx = response.data?.data?.parishes?.total;
      const total = response.data?.data?.parishes?.last_page || 1;
      setTableData1(results);
      setTotalEntries(resultx);
      setTotalPages(total);
      setCurrentPage(page); // Set the current page
      setTotalUsers(total);
  
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
    } finally {
      setProcessLoading(false);
    }
  };
   


  const handleAreaProcess = async (page = 1) => {
    setProcessLoading(true);
  
    try {
      const response = await axios.get(`${BASE_URL1}/parishes/get-all?page=${page}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        params: {
          continent_id: selectedContinent || '',
          region_id: selectedRegion || '',
          province_id: selectedProvince || '',
          zone_id: selectedZone || '',
          area_id: selectedArea || ''
        }
      });
  
      const results = response.data?.data?.data;
      setTableData(results);
      const resultx = response.data?.data?.data?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.data?.last_page || 1;
      setTotalPages(total);
      setCurrentPage(page); 
      setTotalUsers(total);
      // Set the current page
  
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setProcessLoading(false);
    }
  };

  useEffect(() => {
    if (TOKEN && continentName && regionName && provinceName && fetchMode === 'default') {
      fetchAll(1);
    }
  }, [TOKEN, continentName, regionName, provinceName]);
  // REMOVED: useEffect for handleProcess (no longer auto-called)
  // NEW: useEffect to refetch when currentPage changes in 'area' mode
  useEffect(() => {
    if (fetchMode === 'area') {
      handleAreaProcess();
    }
  }, [fetchMode]);



 

  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handleViewFixed = async (id) => {
    setSelectedItemId(id);
    setViewLoading(true);
    console.log(id);
    try {
      const response = await axios.get(`${BASE_URL1}/fixedassets/get-by-type?parish_id=${id}`,

        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${TOKEN}`
          }
        });

      const instructionData1 = response.data?.data?.assets?.data;
      setResponseData(instructionData1);
      const resultx = response.data?.data?.assets?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.assets?.last_page || 1;
      setTotalPages(total);
      console.log(instructionData1, "Am here")

      navigate('/fixed_assets_registers', { state: { parishID: id } });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

    } finally {
      setViewLoading(false);
    }
  }

  const datatoRender = useMemo(() => {
    return fetchMode === 'area' ? tableData : tableData1;
  }, [fetchMode, tableData, tableData1]);
  // const datatoRender = fetchMode === 'area' ? tableData : tableData1;

  // const handleZone = (selectedOption) => {
  //   setSelectedZone(selectedOption.value);
  // };
  // const handleZone = (selectedOption) => {
  //   setSelectedZone(selectedOption.value);
  //   if (!selectedOption.value) {
  //     setFetchMode('default');
  //     fetchAll();
  //   }
  // };
  // const handleContinent = (selectedOption) => {
  //   setSelectedContinent(selectedOption.value);
  //   if (!selectedOption.value) {
  //     setFetchMode('default');
  //     fetchAll();
  //   }
  // };
  // const handleContinent = (selectedOption) => {
  //   setSelectedContinent(selectedOption.value);
  // };
  // const handleRegion = (selectedOption) => {
  //   setSelectedRegion(selectedOption.value);
  //   if (!selectedOption.value) {
  //     setFetchMode('default');
  //     fetchAll();
  //   }
  // };
  // const handleRegion = (selectedOption) => {
  //   setSelectedRegion(selectedOption.value);
  // };
  // const handleProvince = (selectedOption) => {
  //   setSelectedProvince(selectedOption.value);
  // };

  // const handleArea = (selectedOption) => {
  //   setSelectedArea(selectedOption.value);
  // };
  // const handleProvince = (selectedOption) => {
  //   setSelectedProvince(selectedOption.value);
  //   if (!selectedOption.value) {
  //     setFetchMode('default');
  //     fetchAll();
  //   }
  // };
  // const handleArea = (selectedOption) => {
  //   setSelectedArea(selectedOption.value);
  //   if (!selectedOption.value) {
  //     setFetchMode('default');
  //     fetchAll();
  //   }
  // };
  // const handleParish = (selectedOption) => {
  //   // setSelectedParish(selectedOption.value);
  //   setSelectedParish(selectedOption.value);
  //   if (!selectedOption.value) {
  //     setFetchMode('default');
  //     fetchAll();
  //   }
  // };
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      }
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

    const handleFirstPage = () => {
    if (currentPage > 1) {
      if (fetchMode === 'area') {
        handleAreaProcess(1);
      } else {
        fetchAll(1);
      }
    }
  };
  
  const handleLastPage = () => {
    if (currentPage < totalPages) {
      if (fetchMode === 'area') {
        handleAreaProcess(totalPages);
      } else {
        fetchAll(totalPages);
      }
    }
  };
  
  const handlePageClick = (page) => {
    if (page !== currentPage) {
      if (fetchMode === 'area') {
        handleAreaProcess(page);
      } else {
        fetchAll(page);
      }
    }
  };

  const handleZone = (selectedOption) => {
    setSelectedZone(selectedOption?.value || '');
  };
  
  const handleContinent = (selectedOption) => {
    setSelectedContinent(selectedOption?.value || '');
  };
  
  const handleRegion = (selectedOption) => {
    setSelectedRegion(selectedOption?.value || '');
  };
  
  const handleProvince = (selectedOption) => {
    setSelectedProvince(selectedOption?.value || '');
  };
  
  const handleArea = (selectedOption) => {
    setSelectedArea(selectedOption?.value || '');
  };
  
  const handleParish = (selectedOption) => {
    setSelectedParish(selectedOption?.value || '');
  };

const handleTransferProcess = async () => {
    setProcessLoading(true);

    try {
      // We use POST for transfers/updates
      const response = await axios.post(`${BASE_URL1}/parishes/transfer_parish_to_province`, 
        // 1. THE DATA BODY (The Parameters)
        {
          parish_id: transferParishId,
          province_id: selectedProvince, 
          zone_id: selectedZone,
          area_id: selectedArea
        },
        // 2. THE HEADERS
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${TOKEN}`
          }
        }
      );

      // Success Logic
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message || 'Parish transferred successfully!',
      });

      // Close modal and refresh the main table data
      setShowTransferModal(false);
      // Optional: Reset the transfer ID
      setTransferParishId(null); 
         fetchAll(); 
    

    } catch (error) {
      // Error Logic (Copied from your sample)
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          // This handles the validation object you showed me
          // e.g. { province_id: ["Please select..."], ... }
          const messages = Object.values(error.response.data.message).flat();
          errorMessage = messages.join('\n');
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setProcessLoading(false);
    }
};

  return (
    <div>
      <HeaderNav />
<Modal 
  show={showTransferModal} 
  onHide={handleCloseModal}
  size="xl"
>
  <Modal.Header closeButton>
    <Modal.Title>Transfer Parish</Modal.Title>
  </Modal.Header>
  
  <Modal.Body>
    <div 
      className={classes.gridmain} 
      style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(3, 1fr)', // Forces 3 columns
        gap: '20px', 
        alignItems: 'end' 
      }}
    >

      {/* 1. Continent */}
      <div>
        <Form.Label className={classes.filterLabel}>Continent</Form.Label>
        <Select
          // FIX: Matches your ID state (e.g., 7) to the Object (e.g., {value: 7, label: 'Africa'})
          value={tableData10.find(opt => opt.value === selectedContinent) || null}
          
          onChange={(selectedOption) => handleContinent(selectedOption)}
          options={tableData10}
          placeholder="Select Continent"
          menuPortalTarget={document.body}
          styles={selectStyles}
        />
      </div>

      {/* 2. Region */}
      <div>
        <Form.Label className={classes.filterLabel}>Region</Form.Label>
        <Select
          value={tableData4.find(opt => opt.value === selectedRegion) || null}
          
          onChange={(selectedOption) => handleRegion(selectedOption)}
          options={tableData4}
          isDisabled={!selectedContinent}
          placeholder="Select Region"
          menuPortalTarget={document.body}
          styles={selectStyles}
        />
      </div>

      {/* 3. Province */}
      <div>
        <Form.Label className={classes.filterLabel}>Province</Form.Label>
        <Select
          value={tableData5.find(opt => opt.value === selectedProvince) || null}
          
          onChange={(selectedOption) => handleProvince(selectedOption)}
          options={tableData5}
          placeholder="Select Province"
          isDisabled={!selectedRegion}
          menuPortalTarget={document.body}
          styles={selectStyles}
        />
      </div>

      {/* 4. Zone */}
      <div>
        <Form.Label className={classes.filterLabel}>Zone</Form.Label>
        <Select
          value={zones.find(opt => opt.value === selectedZone) || null}
          
          onChange={(selectedOption) => handleZone(selectedOption)}
          options={zones}
          placeholder="Select Zone"
          isDisabled={!selectedProvince}
          menuPortalTarget={document.body}
          styles={selectStyles}
        />
      </div>

      {/* 5. Area */}
      <div>
        <Form.Label className={classes.filterLabel}>Area</Form.Label>
        <Select
          value={areas.find(opt => opt.value === selectedArea) || null}
          
          placeholder='Select Area'
          onChange={(selectedOption) => handleArea(selectedOption)}
          options={areas}
          isDisabled={!selectedZone}
          menuPortalTarget={document.body}
          styles={selectStyles}
        />
      </div>

      {/* 6. Process Button */}
      <Button
        style={{ 
          borderRadius: 5, 
          background: "#092147", 
          width: "100%", 
          height: "38px" 
        }} 
        onClick={handleTransferProcess} 
      >
        {processLoading ? (
          <>
            <Spinner size='sm' />
            <span style={{ marginLeft: '5px' }}>Processing...</span>
          </>
        ) : (
          "Process Transfer"
        )}
      </Button>

    </div>
  </Modal.Body>
</Modal>
      {/* Main Content */}
      <div className={classes.topContainer}>
        {/* <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remittances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Ledger</Button>
        </div> */}

        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Parish</h3>
        <p className={classes.prgText}>View All Parish.</p>

        <div className={classes.subContainer} 
        // style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'nowrap', justifyContent: 'space-between', marginBottom: '-17px', marginTop: '30px' }}
        >
          <div 
          // style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1, marginTop: '-17px' }}
          >
            {/* Continent Filter */}
            <div className={classes.gridmain}>

            {/* <div className={classes.flexone}> */}
            <div 
            // style={{ minWidth: '200px' }}
            >
              <Form.Label className={classes.filterLabel}>Continent</Form.Label>
              <Select
                  onChange={(selectedOption) => handleContinent(selectedOption)}
                  options={tableData10}
                placeholder="Select Continent"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

            <div 
            // style={{ minWidth: '200px' }}
            >
              <Form.Label className={classes.filterLabel}>Region</Form.Label>
              <Select
                  onChange={(selectedOption) => handleRegion(selectedOption)}
                  options={tableData4}
                  isDisabled={!selectedContinent}
                placeholder="Select Region"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

            <div 
            // style={{ minWidth: '200px' }}
            >
              <Form.Label className={classes.filterLabel}>Province</Form.Label>
              <Select
                  onChange={(selectedOption) => handleProvince(selectedOption)}
                  options={tableData5}
                placeholder="Select Province"
                isDisabled={!selectedRegion}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
            {/* </div> */}
            {/* <div className={classes.flextwo}> */}
            <div 
            // style={{ minWidth: '200px' }}
            >
              <Form.Label className={classes.filterLabel}>Zone</Form.Label>
              <Select
                  onChange={(selectedOption) => handleZone(selectedOption)}
                  options={zones}
                placeholder="Select Zone"
                isDisabled={!selectedProvince}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>
            <div 
            // style={{ minWidth: '200px' }}
            >
              <Form.Label className={classes.filterLabel}>Area</Form.Label>
              <Select
                  placeholder='Select Area'
                  onChange={(selectedOption) => handleArea(selectedOption)}
                  options={areas}
                  isDisabled={!selectedZone}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div>

          <Button
                                style={{ borderRadius: 5, marginLeft: "10px", marginTop: "26px", background: "#092147",  }} onClick={() => {
                                  setFetchMode('area');
                                setCurrentPage(1);
                                handleAreaProcess(1);
                                }} >
                                {processLoading ? (
                                  <>
                                    <Spinner size='sm' />
                                    <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                                  </>
                                ) : (
                                  "Process"
                                )}
                              </Button>
            </div>

           
          </div>

        </div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                  <th>Parish Name</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    {/* <th>Province</th> */}
                   {/* <th>Area</th>
                  <th>Zone</th> */}
                    <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {processLoading ? (
                <SkeletonLoader />
              ) : datatoRender.length > 0 ? (
                datatoRender.map((item, index) => (
                  <tr style={{fontSize: "12px"}} key={item.id || index}>
                    
                  <td>{index + 1}</td>
                                                <td>{item.description}</td>
                                                <td>{formatDate(item.created_at)}</td>
                                                <td>{formatDate(item.updated_at)}</td>
                                                {/* <td>{item.province?.description}</td>
                                        <td>{item.area?.description}</td>
                                        <td></td> */}
                                                <td style={{ whiteSpace: 'nowrap' }}>

                                                  <div className="btn btn-success-soft btn-sm mr-1" style={{ backgroundColor: "#28a7451a", color: "green", }} onClick={() => handleViewFixed(item.id,item.description)}>
                                                    {/* <label htmlFor="fileInput" style={{ cursor: 'pointer' }} > */}
                                                    {viewLoading && selectedItemId === item.id ? (
                                                      <Spinner size='sm' />
                                                    ) : (
                                                      // <GrView style={{width: 20, height: 20}}/>
                                                      "View Asset"
                                                    )}
                                                    {/* </label> */}
                                                  </div>
                                                 <div 
  className="btn btn-success-soft btn-sm mr-1" 
  style={{ 
    backgroundColor: "#2828a71a", 
    color: "blue", 
    marginLeft: 10, 
    cursor: "pointer" 
  }}
  onClick={() => handleOpenModal(item)}
>
  Transfer Parish
</div>

                                                </td>
                  </tr>
                ))
              ) : (
                <tr style={{fontSize: "12px"}}>
                  <td colSpan="7" className="text-center p-4" style={{ color: '#6c757d' }}>
                    {searchTerm ? `No area found matching "${searchTerm}"` : "No area available."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={handleFirstPage}
              disabled={currentPage === 1}
            >
              First
            </button>
            <span className={classes.ftOne}>
              {getPageNumbers().map(pageNum => (
                <button
                  key={pageNum}
                  className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                  onClick={() => handlePageClick(pageNum)}
                >
                  {pageNum}
                </button>
              ))}
            </span>
            <button
              className={classes.btnSec}
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
          <p className={classes.displayPag}>
            Displaying {(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, totalUsers)} of {totalUsers} entries
          </p>
        </div>
      </div>
    </div>
  )
}

export default AdminParish;